import useAuth from "../../../auth/useAuth";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { clientByPhoneRoute } from "../../../config";

export const useClientDelivery = (getRoute, getReceiverClient, setLoadingRequest, setErrorRequest) => {
    const auth = useAuth();
    const token = auth.globals.token;

    const {
        showErrorRequest,
        warningAlertRequest
    } = Alerts();


    const getClient = async (values, setFieldValue) => {
        try {
            let res = await fetch(clientByPhoneRoute(values.senders_phone), {
                method: "GET",
                headers: {
                    //"Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                    //"x-access-token": token,
                },
                //cors: 'no-cors'
            })
            let data = await res.json()
            console.log('cliente', data)
            if (res.ok) {
                if (data.length > 0) {
                    setFieldValue("senders_address", data[0].address)
                    setFieldValue("sender_id", data[0].id.toString())
                    setFieldValue("senders_zip", data[0].zip)
                    getRoute(data[0].zip, setFieldValue)
                    setFieldValue("senders_name", data[0].name)
                    setFieldValue("senders_state", data[0].state)
                    setFieldValue("senders_city", data[0].city)
                    setFieldValue("address_line_2", data[0].address_label)
                    getReceiverClient(data[0].id)
                } else {
                    warningAlertRequest('Cliente no encontrado')
                }
            } else {
                if (res.status === 401 || res.status === 403) {
                    showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                } else {
                    showErrorRequest(data.detail, auth)
                }
            }
            setLoadingRequest(false)
            return data;
        } catch (errorRequest) {
            setLoadingRequest(false)
            setErrorRequest(errorRequest)
        }
    }


    return {
        //properties

        //method
        getClient
    }
}